import React from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MainButton from '../../buttons/MainButton';
import classes from './JobAlertModalNew.module.scss';

function DeletePopUp({ deleteHandler, closeHandler, withBackbtn = false, pending = false }) {
  const { t } = useTranslation();

  return (
    <div className={classes.popupContainer}>
      <p className={classes.popupLabel}>{t('dashboard.settings.deletemessage')}</p>
      <MainButton rounded forceWidth="244px" action={deleteHandler}>
        {pending ? <CircularProgress size={20} /> : t('common.general.delete')}
      </MainButton>
      {withBackbtn && (
        <MainButton rounded outlined forceWidth="244px" action={closeHandler}>
          {t('common.general.back')}
        </MainButton>
      )}
    </div>
  );
}

export { DeletePopUp };
